module.exports = __webpack_public_path__ + "static/media/NO.d3ab6c28.svg";